module.exports = __webpack_public_path__ + "media/images/icons/exam-aaebfb7d9a4862442e6025880e7e1508.svg";